document.addEventListener("DOMContentLoaded", function() {
        window.addEventListener("resize", function(e) {
            checkScreenSize(window.innerWidth);
        });
      var mobileMenus = document.querySelectorAll('.mobile-menu');

        if (window.innerWidth < 600) {
          
            mobileMenus.forEach(function(menu) {
                menu.removeEventListener('click', menuClickHandler);
                menu.addEventListener('click', menuClickHandler);
            });
        } else {
            mobileMenus.forEach(function(menu) {
                menu.removeEventListener('click', menuClickHandler);
            });
        }
    
    // Newsletter Check if 'customer_posted' parameter is present in the URL and has a value of 'true'
    if (getURLParameter('customer_posted') === 'true' || getURLParameter('form_type') === 'customer') {
        // Scroll to the section with class "contact-form"
        var contactFormSection = document.querySelector('#ContactForm');
        if (contactFormSection !== null) {
            var contactFormSectionRect = contactFormSection.getBoundingClientRect();
            window.scrollTo({
                top: contactFormSectionRect.top + window.scrollY + contactFormSectionRect.height,
                behavior: 'smooth'
            });
        }
    }
});
function getURLParameter(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

    function checkScreenSize(getWidth) {
        var mobileMenus = document.querySelectorAll('.mobile-menu');

        if (getWidth < 600) {
         
            mobileMenus.forEach(function(menu) {
                menu.removeEventListener('click', menuClickHandler);
                menu.addEventListener('click', menuClickHandler);
            });
        } else {
            mobileMenus.forEach(function(menu) {
                menu.removeEventListener('click', menuClickHandler);
            });
        }
    }

    function menuClickHandler() {
        var clickedWidgetBody = this.nextElementSibling;
           console.log('heekedld');
        if (clickedWidgetBody.classList.contains('menu-open')) {
            clickedWidgetBody.classList.remove('menu-open');
            this.classList.remove('acc-down');
        } else {
            closeAllMenus();
            clickedWidgetBody.classList.add('menu-open');
            this.classList.add('acc-down');
        }
    }

    function closeAllMenus() {
        var widgetBodies = document.querySelectorAll('.widget-body');
        var mobileMenus = document.querySelectorAll('.mobile-menu');
        
        widgetBodies.forEach(function(widgetBody) {
            widgetBody.classList.remove('menu-open');
        });
        
        mobileMenus.forEach(function(menu) {
            menu.classList.remove('acc-down');
        });
    }

